<template>
  <article>
    <div class="flex">
      <div class="nav-item pointer" :class="{'nav-item-active':item.isActive}" v-for="(item, index) in settingNav" :key="index" @click="navChange(index)">{{item.name}}</div>
    </div>
    <div v-show="settingNav[0].isActive">
      <div v-if="shop">
        <div class="flex flex-1">
          <div class="flex flex-1 aic mt-40 mr-30">
            <div class="form-item">今日上新：</div>
            <el-select v-model="detail.today_new" multiple filterable clearable default-first-option size="medium" placeholder="请选择商品">
              <el-option v-for="item in goodsLists" :key="item.sgid" :label="item.title" :value="item.sgid"></el-option>
            </el-select>
          </div>
          <div class="flex flex-1 aic mt-40 mr-30">
            <div class="form-item">热门搜索：</div>
            <el-select v-model="detail.hot_search" multiple filterable clearable default-first-option size="medium" placeholder="请选择商品">
              <el-option v-for="item in goodsLists" :key="item.sgid" :label="item.title" :value="item.sgid"></el-option>
            </el-select>
          </div>
          <div class="flex flex-1 aic mt-40 mr-30">
            <div class="form-item">推荐好物：</div>
            <el-select v-model="detail.recommend" multiple filterable clearable default-first-option size="medium" placeholder="请选择商品">
              <el-option v-for="item in goodsLists" :key="item.sgid" :label="item.title" :value="item.sgid"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex flex-1">
          <div class="flex flex-1 aic mt-40 mr-30">
            <div class="form-item">v1佣金分成：</div>
            <el-input v-model="detail.level_ratio.v1" placeholder="" size="small" style="width:135px">
              <template slot="append">%</template>
            </el-input>
          </div>
          <div class="flex flex-1 aic mt-40 mr-30">
            <div class="form-item">v2佣金分成：</div>
            <el-input v-model="detail.level_ratio.v2" placeholder="" size="small" style="width:135px">
              <template slot="append">%</template>
            </el-input>
          </div>
          <div class="flex flex-1 aic mt-40 mr-30">
            <div class="form-item">v3佣金分成：</div>
            <el-input v-model="detail.level_ratio.v3" placeholder="" size="small" style="width:135px">
              <template slot="append">%</template>
            </el-input>
          </div>
          <div class="flex flex-1 aic mt-40 mr-30">
            <div class="form-item">v4佣金分成：</div>
            <el-input v-model="detail.level_ratio.v4" placeholder="" size="small" style="width:135px">
              <template slot="append">%</template>
            </el-input>
          </div>
          <div class="flex flex-1 aic mt-40 mr-30">
            <div class="form-item">同等级佣金：</div>
            <el-input v-model="detail.level_ratio.same" placeholder="" size="small" style="width:135px">
              <template slot="append">%</template>
            </el-input>
          </div>
        </div>
      </div>
      <div v-if="earn">
        <div class="flex flex-1">
          <div class="flex flex-1 aic mt-40 mr-30">
            <div class="form-item">首次任务奖励：</div>
            <el-input v-model="detail.first_reward"  @input="(v)=>(detail.first_reward=v.replace(/[^\d.]/g,''))" placeholder="" size="small" style="width:135px">
            </el-input>
          </div>
          <div class="flex flex-1 aic mt-40 mr-30">
            <div class="form-item">师傅分成：</div>
            <el-input v-model="detail.father_ratio"  @input="(v)=>(detail.father_ratio=v.replace(/[^\d]/g,''))" placeholder="" size="small" style="width:135px">
              <template slot="append">%</template>
            </el-input>
          </div>
          <div class="flex flex-1 aic mt-40 mr-30">
            <div class="form-item">师祖分成：</div>
            <el-input v-model="detail.grandfather_ratio"  @input="(v)=>(detail.grandfather_ratio=v.replace(/[^\d]/g,''))" placeholder="" size="small" style="width:135px">
              <template slot="append">%</template>
            </el-input>
          </div>
        </div>
      </div>
      <div class="flex jcc mt-40">
        <div class="blue-large-btn mt-40" @click="marketEdit">保存</div>
      </div>
    </div>
  </article>
</template>
<script>
import util from '../../../script/util'
import {getMarketDetail, marketEdit, shopGoodsLists} from '../../../api/api'
import uploadHeadImage from '../../../components/uploadImage.vue'
export default {
  name: 'shopCategory',
  components: {
    uploadHeadImage
  },
  data () {
    return {
      settingNav: [
        {
          name: this.market_name,
          isActive: true
        },
        {
          name: '基本',
          isActive: false
        },
        {
          name: '管理文字回复',
          isActive: false
        },
        {
          name: '添加文字回复',
          isActive: false
        }
      ],
      goodsLists: [],
      listLoading: false,
      bbj: false,
      shop: false,
      earn: false,
      market_name: '',
      detail: {
        market: '',
        hot_search: [],
        recommend: [],
        level_ratio: {
          v1: 95,
          v2: 80,
          v3: 70,
          v4: 0,
          same: 1
        },
        first_reward: 1,
        father_ratio: 10,
        grandfather_ratio: 5
      }
    }
  },
  methods: {
    navChange (index) {
      let settingNav = this.settingNav
      settingNav.forEach((item) => {
        item.isActive = false
      })
      settingNav[index].isActive = true
      this.settingNav = settingNav
    },
    marketEdit () {
      let settings = {
        today_new: this.detail.today_new,
        hot_search: this.detail.hot_search,
        recommend: this.detail.recommend,
        level_ratio: this.detail.level_ratio,
        first_reward: this.detail.first_reward,
        father_ratio: this.detail.father_ratio,
        grandfather_ratio: this.detail.grandfather_ratio
      }

      let content = ''
      if (this.detail.market === 3) {
        if (settings['first_reward'] === '') {
          content = '首次奖励不能为空'
        }

        if (settings['father_ratio'] === '') {
          content = '师傅分成比例不能为空'
        }

        if (settings['grandfather_ratio'] === '') {
          content = '师祖分成比例不能为空'
        }
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      let params = {
        market: this.detail.market,
        settings: JSON.stringify(settings)
      }

      this.listLoading = true
      marketEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.listLoading = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    getMarketDetail () {
      let params = {
        market: this.detail.market
      }
      getMarketDetail(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          if (this.detail.market === 2) {
            this.detail.today_new = data.d.settings.today_new
            this.detail.hot_search = data.d.settings.hot_search
            this.detail.recommend = data.d.settings.recommend
            this.detail.level_ratio = data.d.settings.level_ratio
          }
          if (this.detail.market === 3) {
            this.detail.first_reward = data.d.settings.first_reward
            this.detail.father_ratio = data.d.settings.father_ratio
            this.detail.grandfather_ratio = data.d.settings.grandfather_ratio
          }
        }
      })
    },
    getGoodsLists () {
      let params = {
      }

      this.listLoading = true
      shopGoodsLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.goodsLists = data.d.lists.map((item, index) => {
            return {
              title: item.title + '(' + item.sgid + ')',
              sgid: item.sgid
            }
          })
        }
      })
    }
  },
  mounted () {
    this.detail.market = parseInt(util.getCookie('market'))
    this.market_name = util.formatMarket(this.detail.market)
    this.settingNav[0].name = this.market_name
    this.getGoodsLists()
    this.getMarketDetail()
    if (this.detail.market === 1) {
      this.bbj = true
      console.log('bbj')
    }
    if (this.detail.market === 2) {
      this.shop = true
      console.log('shop')
    }
    if (this.detail.market === 3) {
      this.earn = true
      console.log('earn')
    }
  },
  watch: {
  }
}
</script>

<style scoped>
  .nav-item{
    width: 140px;
    height: 36px;
    background-color: #e5e5e5;
    text-align: center;
    line-height: 36px;
  }
  .nav-item:hover{
    background-color: #999;
  }
  .nav-item-active{
    background-color: #0088ff;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/page/module/main/setting.vue